(function () {
    document.addEventListener("DOMContentLoaded", (event) => {
        const allSearchFilters = document.querySelectorAll(".filter-input");
        const searchForm = document.getElementById("search-form-2");

        if (searchForm != null) {
            Array.prototype.forEach.call(allSearchFilters, (filter) => {
                filter.addEventListener("click", (e) => searchForm.submit());
            });
        }

        const loadMoreBtn = document.querySelector('.search-results-module .loadMoreBtn');

        if (loadMoreBtn) {
	        let currentPage = 1;
            let remainingPageCount = searchForm.getAttribute('data-total-pages') - 1;

            toggleLoadMore(remainingPageCount, loadMoreBtn);

            loadMoreBtn.addEventListener('click', (e) => {
                var queryString = window.location.search;
                
                if (queryString.length > 0) {
                    currentPage++;
                    queryString += '&page=' + currentPage;
                    
                    queryString = sanitize(queryString);

                    var request = new XMLHttpRequest();
                    request.open('GET', '/umbraco/api/SearchApi/LoadMoreResults' + queryString, true);
 
                    request.onload = function () {
                        if (request.status >= 200 && request.status < 400) {
                            var results = JSON.parse(request.responseText);

                            if (results.length > 0) {
                                let loadMoreItems = [];

                                results.forEach((r) => {
                                    var hasTag = r.Tag.length > 0;
                                    var hasMinutes = r.MinutesToRead > 0;
                                    var hasLastUpdated = r.LastUpdated.length > 0;

                                    var itemEl =
                                        `<li class="filter-item" data-filter-jobs="">
												<div class="search-result">
													<h2 class="has-text-primary has-font-size-5">
														<a href="${r.Url}" class="has-font-weight-bold">${r.Title}</a>
													</h2>
													<p class="is-small has-font-weight-bold has-text-gray-100">
														${hasTag ? 
                                            				r.Tag : ''
				                                        }
														${hasTag && (hasMinutes || hasLastUpdated) ? '|' : ''}
														${hasMinutes ? r.MinutesToRead + ' min read' : ''}
														${hasMinutes && hasLastUpdated ? '|' : ''}
														${hasLastUpdated ?
															'Last updated: ' + new Date(r.LastUpdated).toLocaleDateString('en-GB') : ''
														}
													</p>
													<p>
														${r.Summary}
													</p>
													<a href="${r.Url}">
														<p class="has-font-weight-bold has-text-gray-90 has-mt-0 has-mb-3">Read more</p>
													</a>
												</div>
											</li>`;

                                    loadMoreItems.push(itemEl);
                                });

                                const container = document.querySelector('.search-results-module ul');
                                container.innerHTML += loadMoreItems.join(' ');

                                remainingPageCount--;
                                toggleLoadMore(remainingPageCount, loadMoreBtn);
                            }
                        }
                    };

                    request.onerror = function () {
                        currentPage--;
                        //console.log('search-results.js - Error getting more results');
                    };

                    request.send();
                }
            });
        }
    });

    function toggleLoadMore(remainingPageCount, loadMoreBtn) {
        if (remainingPageCount === 0) {
            loadMoreBtn.style.display = 'none';
        }
    }

    function sanitize(str) {
        return str.replace(/&/g, "&amp;")
                  .replace(/</g, "&lt;")
                  .replace(/>/g, "&gt;")
                  .replace(/"/g, "&quot;")
                  .replace(/'/g, "&#039;");
    }
})();